<script setup lang="ts">
import type { KidDiscipline } from '../model/interfaces'

import { KidBalanceItem } from '@shared/ui/cards'
import { LinkTextPrimaryMedium } from '@shared/ui/links'

import { useKidDisciplineBalance } from '../model/kid-discipline-balance.hook'

defineOptions({
  name: 'KidDisciplineBalance',
})

const props = defineProps<{
  discipline: KidDiscipline
}>()

const {
  refTitle,
  refUrl,
  generalRows,
  bookingRows,
} = useKidDisciplineBalance({
  discipline: computed(() => props.discipline),
})
</script>

<template>
  <div class="kid-discipline-balance">
    <div class="kid-discipline-balance__head">
      <LinkTextPrimaryMedium :href="refUrl">
        {{ refTitle }}
      </LinkTextPrimaryMedium>
      <div class="kid-discipline-balance__group">
        <KidBalanceItem
          v-for="row in generalRows"
          :key="row.label"
          :label="row.label"
          :value="row.value"
          :tooltip="row.tooltip"
        />
      </div>
    </div>
    <div class="kid-discipline-balance__group">
      <KidBalanceItem
        v-for="row in bookingRows"
        :key="row.label"
        :label="row.label"
        :value="row.value"
        :tooltip="row.tooltip"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./KidDisciplineBalance.scss" />
